module.exports = __webpack_public_path__ + "img/edit-gray.0da885f4.svg";